
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-an-affiliate",
      function () {
        return require("private-next-pages/become-an-affiliate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-an-affiliate"])
      });
    }
  